import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/material";
import { mesfColors } from "@setup/ag-grid/mesf-theme";
import { FC } from "react";
import { FileProperties } from "../../models/FileProperties";
import { TypeIcon } from "../TypeIcon";

export type DropFeedback = { canDrop: boolean; text: string } | null;

type Props = {
	monitorProps: DragLayerMonitorProps<FileProperties>;
	feedback?: DropFeedback;
};

export const CustomDragPreview: FC<Props> = (props) => {
	const item = props.monitorProps.item;
	const { feedback } = props;

	return (
		<Box sx={{ display: "grid", gap: "4px", pointerEvents: "none" }}>
			<Box
				sx={{
					alignItems: "center",
					backgroundColor: mesfColors.info.dark,
					borderRadius: "4px",
					boxShadow:
						"0 12px 24px -6px rgba(0, 0, 0, .25), 0 0 0 1px rgba(0, 0, 0, .08)",
					color: "#fff",
					display: "inline-grid",
					fontSize: "0.875rem",
					gap: "8px",
					gridTemplateColumns: "auto auto",
					justifySelf: "start",
					padding: "4px 8px",
				}}
			>
				<Box sx={{ alignItems: "center", display: "flex" }}>
					<TypeIcon
						droppable={item.droppable!}
						fileType={item?.data?.fileType}
					/>
				</Box>
				<Box sx={{ alignItems: "center", display: "flex" }}>{item.text}</Box>
			</Box>
			{feedback && (
				<Box
					sx={{
						alignItems: "center",
						backgroundColor: mesfColors.background.paper,
						border: `1px solid ${feedback.canDrop ? mesfColors.success.main : mesfColors.error.main}`,
						borderRadius: "4px",
						color: feedback.canDrop
							? mesfColors.success.main
							: mesfColors.error.dark,
						display: "flex",
						fontSize: "0.8125rem",
						gap: "6px",
						justifySelf: "start",
						maxWidth: 420,
						padding: "4px 8px",
					}}
				>
					{feedback.canDrop ? (
						<CheckCircleIcon fontSize="small" />
					) : (
						<BlockIcon fontSize="small" />
					)}
					{feedback.text}
				</Box>
			)}
		</Box>
	);
};
